import moment from 'moment-timezone';
import { TripWithStopsDetails } from '../store/config/types';
import { CostInput } from '../store/config/types/cost.types';
import axios from './axios';

async function getSubjectCosts(subject: string, subjectId: string): Promise<CostInput[] | undefined> {
  const res = await axios.get(`/costs/${subject}/${subjectId}`);
  return res.data.data;
}

async function deleteCost(costInputId: number): Promise<boolean | undefined> {
  const res = await axios.delete(`/costs/${costInputId}`);
  return res.data.data;
}

async function editCost(
  subject: string,
  subjectId: string,
  costInputId: number,
  value: number,
): Promise<boolean | undefined> {
  const res = await axios.patch(`/costs/${subject}/${subjectId}`, { costInputId, value });
  return res.data.data;
}

async function newCost(
  subject: string,
  subjectId: string,
  costInputCategory: string,
  UoM: string,
  value: number,
): Promise<CostInput> {
  const res = await axios.post(`/costs/${subject}/${subjectId}`, { costInputCategory, UoM, value });
  return res.data.data;
}

async function updateTripsTotalCosts(trips: TripWithStopsDetails[]) {
  try {
    const { data } = await axios.post(`/costs/simulate-trips-cost`, {
      trips: trips.map((trip) => {
        let plannedEndsAt = trip.returnAt;
        let plannedStartsAt = trip.startsAt;
        if (!plannedEndsAt) {
          trip.tripStops?.forEach((stop) => {
            if (!plannedEndsAt || moment(plannedEndsAt).isBefore(stop.routerDepartureAt)) {
              plannedEndsAt = new Date(stop.routerDepartureAt);
            }
            if (!plannedStartsAt || moment(plannedStartsAt).isAfter(stop.routerArrivalAt)) {
              plannedStartsAt = new Date(stop.routerArrivalAt);
            }
          });
        }
        return {
          isRoundTrip: Boolean(trip.isRoundTrip),
          returnAt: trip.returnAt,
          plannedEndsAt,
          plannedStartsAt,
          vehicleId: trip.vehicleId,
          courierId: trip.courierId,
          totalMiles: trip.totalMiles,
        };
      }),
    });
    if (data.result) {
      const tripsTotals: any[] = data.data;
      console.log({ totalPlannedCost: tripsTotals.reduce((total, t: any) => total + (t.totalPlannedCost ?? 0), 0) });
      for (let i = 0; i < trips.length; i++) {
        trips[i].additionalData = {
          ...(trips[i].additionalData ?? {}),
          totalCost: tripsTotals[i].totalPlannedCost,
        };
      }
    }
  } catch (err) {
    console.error(err);
  }
  return trips;
}
export const CostService = {
  getSubjectCosts,
  deleteCost,
  editCost,
  newCost,
  updateTripsTotalCosts,
};
